import React, { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Skeleton } from "@mui/material";
import dayjs from "dayjs";
// import { Table } from "antd";
import { getAppointmentSlotDetails } from "../../connections/getAppointmentSlotDetails";
import { deleteAppointmentSlot } from "../../connections/deleteAppointmentSlot";
import { toast } from "react-toastify";
import { imagesend } from "../imagepath";
import { formatDateTime } from "../../utils/constant/constant";

const ShowAppointmentSlot = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const { id } = useParams();
  const navigate = useNavigate();
  const [AppId, setAppId] = useState(null);
  const { data: appointmentSlotData, isLoading } = useQuery({
    queryKey: ["getAppointmentSlotDetails", id],
    queryFn: () => getAppointmentSlotDetails(user?.token, id),
    enabled: !!id,
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  // const columns = [
  //   {
  //     title: "Code",
  //     dataIndex: "code",
  //   },
  //   {
  //     title: "Slot Type",
  //     dataIndex: "slot_type",
  //   },
  //   {
  //     title: "Hour",
  //     dataIndex: "hour",
  //   },
  //   {
  //     title: "Minutes",
  //     dataIndex: "minutes",
  //   },
  //   {
  //     title: "Meridiem",
  //     dataIndex: "meridiem",
  //   },

  //   {
  //     title: "Created At",
  //     dataIndex: "created_at",
  //     render: (date) => (
  //       <>
  //         {date}
  //       </>
  //     ),
  //   },
  //   {
  //     title: "Updated At",
  //     dataIndex: "updated_at",
  //     render: (date) => (
  //       <>
  //         {date}
  //       </>
  //     ),
  //   },
  // ];
  const formatDate = (date) =>
    formatDateTime(date);
  const handleDeleteAppointmentSlot = async (e) => {
    e.preventDefault();
    try {
      const data = await deleteAppointmentSlot(user?.token, AppId);
      if (data.status.status === "SUCCESS") {
        toast.success("Appointment Slot Deleted Successfully");
        navigate(-1);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  return (
    <>
      <Header />
      <Sidebar activeClassName="appointment-slot-list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">
                      <Link to={-1}>Appointment Slot Details</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{id}</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* content Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="doctor-table-blk"
                          >
                            <h3>Appointment Slot Details</h3>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                              className="doctor-search-blk"
                            >
                              <button
                                className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                onClick={() => {
                                  navigate("/admin/update-appointment_slot", {
                                    state: appointmentSlotData,
                                  });
                                }}
                              >
                                <i className="far fa-edit me-2" />
                                Edit
                              </button>

                              <button
                                className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                                style={{
                                  minWidth: "100px",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#delete_patient"
                                onClick={() => {
                                  setAppId(appointmentSlotData?.id);
                                }}
                              >
                                <i className="fa fa-trash-alt me-2" />
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLoading ? (
                      <div>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={430}
                        />
                      </div>
                    ) : (
                      <div className="content-details">
                        <div className="col-lg-12">
                          <div className="card-box">
                            <div className="card-block">
                              <ul className="personal-info">
                                <li className="pb-1">
                                  <span className="title">Code:</span>
                                  <span className="text">
                                    {appointmentSlotData?.code || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Slot Type:</span>
                                  <span className="text">
                                    {appointmentSlotData?.slot_type || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Hour:</span>
                                  <span className="text">
                                    {appointmentSlotData?.hour || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Minutes:</span>
                                  <span className="text">
                                    {appointmentSlotData?.minutes || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Meridiem:</span>
                                  <span className="text">
                                    {appointmentSlotData?.meridiem || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Created At:</span>
                                  <span className="text">
                                    {formatDate(
                                      appointmentSlotData?.created_at
                                    ) || "N/A"}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Updated At:</span>
                                  <span className="text">
                                    {formatDate(
                                      appointmentSlotData?.updated_at
                                    ) || "N/A"}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      // <div className="table-responsive">
                      //   <Table
                      //     columns={columns}
                      //     dataSource={[appointmentSlotData]}
                      //     pagination={false}
                      //     scroll={{ x: "max-content" }}
                      //   />
                      // </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button
                    onClick={handleDeleteAppointmentSlot}
                    type="submit"
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            id="delete_patient"
            className="modal fade delete-modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <img src={imagesend} alt="#" width={50} height={46} />
                  <h3>Are you sure want to delete this ?</h3>
                  <div className="m-t-20">
                    {" "}
                    <Link
                      to="#"
                      className="btn btn-white me-2"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </Link>
                    <button type="submit" className="btn btn-danger">
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};
export default ShowAppointmentSlot;
